// Współdzielona, modułowa pamięć koszyka gościa.
//
// Wydzielona z useAddToCartFlow, żeby useCartQuery (queries/useStoreApi) mógł ją
// zresetować po wykryciu utraconej sesji (sessionLost) BEZ cyklicznego importu
// useStoreApi <-> useAddToCartFlow. To leaf-moduł: nie importuje niczego z warstwy
// zapytań, więc nadaje się też do izolowanych testów jednostkowych (node env).

let lastKnownGuestCartId = 0
let guestCartCreationPromise: Promise<unknown> | null = null

export function getLastKnownGuestCartId(): number {
  return lastKnownGuestCartId
}

// Zapamiętuje id koszyka gościa. Ignoruje wartości <= 0 (0 = brak/utracony koszyk),
// żeby przypadkowy pusty odczyt nie „utrwalił" zerowego id.
export function setLastKnownGuestCartId(id: number): void {
  if (id > 0) {
    lastKnownGuestCartId = id
  }
}

export function getGuestCartCreationPromise(): Promise<unknown> | null {
  return guestCartCreationPromise
}

export function setGuestCartCreationPromise(promise: Promise<unknown> | null): void {
  guestCartCreationPromise = promise
}

// Zrzuca modułową pamięć koszyka gościa. Wołane:
//  (1) po złożeniu zamówienia — core PS9 „zamyka" koszyk (orderExists → unset
//      id_cart w cookie, nowy pusty koszyk), więc trzymanie starego id sprawia,
//      że ensureGuestCart() robi early-return na nieistniejący już koszyk;
//  (2) gdy odczyt koszyka wykryje utraconą sesję (sessionLost) — by przy kolejnym
//      dodaniu ensureGuestCart() re-provisionował świeżą sesję zamiast POST-ować
//      w martwy koszyk.
export function resetGuestCartCache(): void {
  lastKnownGuestCartId = 0
  guestCartCreationPromise = null
}
